import { Headphones, Video, Check, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { BACKEND, euros } from "@/lib/ceda";

export const CapsuleCard = ({ c, accent, selectable, selected, disabled, owned, price, onToggle, onOpen, onBuy, index = 0 }) => {
  const MediaIcon = c.media_type === "audio" ? Headphones : Video;
  return (
    <article
      data-testid={`ceda-card-${c.id}`}
      style={{ animationDelay: `${index * 60}ms` }}
      className={`group relative rounded-3xl bg-white border overflow-hidden flex flex-col animate-in fade-in slide-in-from-bottom-3 duration-500 fill-mode-both transition-[border-color,transform,box-shadow] hover:-translate-y-1 hover:shadow-[0_18px_40px_-24px_rgba(31,42,36,0.45)] ${selected ? "border-[#C9A24B] ring-2 ring-[#C9A24B]/40" : "border-[#E8DCC4]"}`}
    >
      <button onClick={onOpen} className="text-left" data-testid={`ceda-card-open-${c.id}`}>
        <div className="relative h-36" style={{ background: `linear-gradient(135deg, ${accent}26, ${accent}08)` }}>
          {c.cover_url && <img src={`${BACKEND}${c.cover_url}`} alt="" className="absolute inset-0 w-full h-full object-cover" />}
          <span className="absolute top-3 left-3 rounded-full bg-white/90 px-3 py-1 font-ui text-[11px] tracking-[0.18em] text-[#1F2A24]">{c.code}</span>
          <span className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/90 flex items-center justify-center" style={{ color: accent }}>
            <MediaIcon size={15} />
          </span>
        </div>
        <div className="p-5">
          <h3 className="font-serif text-xl text-[#1F2A24] leading-snug">{c.title}</h3>
          <p className="font-sans text-sm text-[#1F2A24]/65 mt-2 line-clamp-3">{c.intention || c.benefit}</p>
        </div>
      </button>
      <div className="mt-auto px-5 pb-5 flex items-center justify-between gap-2">
        {owned ? (
          <Link to="/mon-espace/ceda" data-testid={`ceda-card-owned-${c.id}`} className="inline-flex items-center gap-1.5 rounded-full bg-[#385E3A]/10 text-[#385E3A] px-4 py-2 font-ui text-xs">
            <Check size={14} /> Dans Mes CEDA
          </Link>
        ) : selectable ? (
          <button
            data-testid={`ceda-card-select-${c.id}`}
            disabled={disabled && !selected}
            onClick={onToggle}
            className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 font-ui text-xs transition-colors disabled:opacity-40 ${selected ? "bg-[#C9A24B] text-[#1F2A24]" : "border border-[#C9A24B] text-[#1F2A24] hover:bg-[#C9A24B]/10"}`}
          >
            {selected ? <><Check size={14} /> Choisie</> : <><Plus size={14} /> Ajouter au pack</>}
          </button>
        ) : (
          <button
            data-testid={`ceda-card-buy-${c.id}`}
            onClick={onBuy}
            className="rounded-full bg-[#1F2A24] text-white px-4 py-2 font-ui text-xs hover:bg-black transition-colors"
          >
            Obtenir · {euros(price)}
          </button>
        )}
        <button onClick={onOpen} className="font-sans text-xs text-[#385E3A] underline-offset-4 hover:underline">Voir la fiche</button>
      </div>
    </article>
  );
};
